import React from 'react'

export default function buttonLight(props) {
    return (
        <button className={props.classValue} onClick={props.onClick}>
            <span>{props.textValue}</span>
        </button>
    )
}
